const Config = {
  API_KEY: 'IMwVVbHnDc9b8oApaRQ8xaJ7Xlatb57432VKNR1h',
  Pool: {
    UserPoolId: 'ap-southeast-1_T1qGozK2W',
    ClientId: '7o4k0uudsf6pdnapv415oqcduf'
  }
};
  
export default Config;
